import { useState } from "react";
import { saveSupplyType } from "../Api/SupplyTypeMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const SupplyTypeMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const [supplyTypeData, setSupplyTypeData] = useState({
    supplyTypeCode: "",
    supplyTypeDescription: "",
  });

  const handleChange = (e) => {
    setSupplyTypeData({ ...supplyTypeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveSupplyType(supplyTypeData, userId); 
      toast.success(`🦄 Supply Type Added Successfully`);
      setSupplyTypeData({
        supplyTypeCode: "",
        supplyTypeDescription: "",
      });
      
    } catch (error) {
      toast.error(`🦄 Error saving supply type: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Supply Type Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Supply Type Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="supplyTypeCode"
                    value={supplyTypeData.supplyTypeCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Supply Type Description <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="supplyTypeDescription"
                    value={supplyTypeData.supplyTypeDescription}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button 
                variant="primary" 
                type="submit" 
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Supply Type"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default SupplyTypeMaster;